import axios from "axios";
import {API_HOST} from "../core/variables";


class InvitationRepository {
    async find_with_email(email: string) {
        return axios.get(`${API_HOST}/v1/onboarding/invitations`, {
            params: {
                email: email
            }
        })
    }
}
const invitationRepository = new InvitationRepository();

export default invitationRepository
